import { GET_AVAILABLE_ROLES } from '@/graphql';
import { useLazyQuery } from '@vue/apollo-composable';

export function useAvailableRoles(autoFetch = true) {
  const {
    result,
    loading,
    error,
    refetch,
    load,
    onResult,
  } = useLazyQuery(GET_AVAILABLE_ROLES, undefined);

  if (autoFetch) load();

  return {
    availableRolesResult: result,
    loadingAvailableRoles: loading,
    errorAvailableRoles: error,
    refetchAvailableRoles: refetch,
    loadAvailableRoles: load,
    onResultAvailableRoles: onResult,
  };
}
